import { Image } from '@byecode/ui'
import { getAssetUrl } from '@lighthouse/assets'
import { AccountBox, isMobileDevice, useAtomAction } from '@lighthouse/shared'
import React, { useCallback, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import { consummateInfoAtom } from '@/atoms/auth/action'
import { encrypt } from '@/utils'

import * as SC from '../styles'
import { BetaRequestForm } from './BetaRequestForm'
import { StepIndicator } from './BetaRequestForm/StepIndicator'

const SCxContainer = styled.div`
    width: 100%;
    height: 100%;
`

const SCxContent = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`

const SCxHeader = styled.div`
    width: 100%;
    height: 15vh;
    padding: 20px 20px 0 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`

export const PerfectInfo: React.FC = () => {
    const isMobile = isMobileDevice()
    const navigate = useNavigate()
    const [currentStep, setCurrentStep] = useState(0)
    const { run: consummateInfo } = useAtomAction(consummateInfoAtom)
    const [searchParams] = useSearchParams()

    const redirect = searchParams.get('redirect')
    // 完成
    const finish = useCallback(
        async (data: any) => {
            const { username, password, spaceName, spaceIcon } = data
            const enctyptPassword = encrypt(password)
            const params = {
                username,
                password: enctyptPassword || '',
                spaceName,
                spaceIcon
            }
            const isPerfect = await consummateInfo(params)
            if (isPerfect) {
                searchParams.delete('redirect')
                const search = searchParams.toString()
                navigate(
                    { pathname: redirect || '/', search },
                    {
                        replace: true
                    }
                )
            }
        },
        [consummateInfo, navigate, redirect, searchParams]
    )

    const handleChangeStep = useCallback((num: number) => {
        setCurrentStep(num)
    }, [])

    return (
        <SCxContainer>
            <SCxHeader>
                <Image key="logo" style={{ userSelect: 'none' }} src={getAssetUrl('common', 'logo.png')} width={100} />
            </SCxHeader>
            <SCxContent>
                <StepIndicator currentStep={currentStep} isMobile={isMobile} />
                <AccountBox height="auto">
                    <SC.FormContainer>
                        <BetaRequestForm step={currentStep} onChangeStep={handleChangeStep} onSubmit={finish} />
                    </SC.FormContainer>
                </AccountBox>
            </SCxContent>
        </SCxContainer>
    )
}
